import { FC } from "react";
import { Button, Skeleton } from "antd";
import { useTranslation } from "react-i18next";
import { SegmentCountType } from "src/constants/filters";
import { explode } from "src/utility/objects";
import { getNumberLocale } from "src/utility";

type ResetButtonProps = {
  dataCount: SegmentCountType;
  isFetching?: boolean;
};

const ResetButton: FC<ResetButtonProps> = ({ dataCount, isFetching }) => {
  const { t } = useTranslation();
  const { segmentCount, totalCount } = explode(dataCount, { totalCount: 0, segmentCount: 0 });
  return (
    <div className="flex items-center justify-between ps-3">
      {isFetching ? (
        <Skeleton.Input classNames={{ content: "h-full!", root: "h-4!" }} active />
      ) : (
        <span>
          <span className="text-font-active text-base font-bold">{segmentCount.toLocaleString(getNumberLocale())}</span>{" "}
          {t("Filters.resultsCount", { total: totalCount.toLocaleString(getNumberLocale()) })}
        </span>
      )}
      <Button type="text" className="bg-transparent! text-font-active! font-semibold! text-base!" htmlType="reset">
        {t("Filters.clear")}
      </Button>
    </div>
  );
};

export default ResetButton;
